import { TypeRequest } from "../common/enums/AllEnums";
import { IResponse } from "../interfaces/IResponse";
import { IUserInformation, IUserProject } from "../interfaces/IUser";
import { BisAPI, BisApiRequest } from "./apis";

export const getUserByID = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerUsuarioByIDAndByProyectoID?usuarioID=${userID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getUsers = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerUsuariosByUsuarioIDAndProyectoID?usuarioID=${userID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getUsersByProyectoID = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerUsuariosByProyectoID?`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getMenuByUserID = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerMenusByUsuarioIDAndProyectoID?usuarioID=${userID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}


export const updateUser = (user: IUserInformation): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ActualizarUsuarioByProyectoID`, TypeRequest.put, user).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertUser = (user: IUserInformation): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/InsertarUsuarioByProyectoID`, TypeRequest.post, user).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const DeactiveUserById = (user: IUserInformation): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/DesactivarUsuarioProyecto?usuarioProyectoID=${user.usuarioProyecto!.usuarioProyectoID!}`, TypeRequest.put).then((response) => {
            return BisApiRequest(`Usuario/DesactivarUsuarioByUsuarioGUIDAndDepartamentoGUID?usuarioGUID=${user.usuarioGUID}&departamentoGUID=${user.usuarioProyecto!.departamentoGUID}`, TypeRequest.put)
                .then((response) => {
                }).catch((error: any) => {
                    reject(error?.response?.data);
                })
                .finally(() => {
                    resolve(response.data);
                });
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getSexType = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Proyecto/ObtenerSexoTipo', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getUserByUserName = (userName: string): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerUsuarioByNombreUsuarioAndByProyectoID?nombreUsuario=${userName}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getPuestosByUserID = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerPuestosByUsuarioID?usuarioID=${userID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}





